import {inject}                                 from '@angular/core';
import {CanActivateFn, RedirectCommand, Router} from '@angular/router';
import {AuthUnlockService}                      from './auth-unlock.service';

export const authCryptoGuard: CanActivateFn = (route, state) => {
	const unlockService = inject(AuthUnlockService);
	const router = inject(Router);

	if (unlockService.isUnlocked()) {
		return true;
	} else {
		const urlTree = router.createUrlTree(['/unlock'], {
			queryParams: {returnUrl: state.url}
		});
		return new RedirectCommand(urlTree);
	}
};
